import React from 'react'

import { CardsList } from './CardsList/CardsList'

import { useDocumentTitle } from 'common/hooks'
import { SectionHeader } from 'layout'

type PropsType = {}

export const Statistics = ({}: PropsType) => {
  useDocumentTitle(`Code Typing статистика`)

  return (
    <section>
      <SectionHeader title="Статистика" />
      <CardsList />
    </section>
  )
}
